module.exports = __webpack_public_path__ + "static/arbol-512c7e73f34965f26fe907d329231b90.png";